// src/App.js
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

// Protected Routes
import StudentProtectedRoutes from './routes/StudentProtectedRoutes';

// Layout
import PublicLayout from './layouts/PublicLayout';

// Auth Pages
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import ForgotPassword from './pages/auth/ForgotPassword';
import ResetPassword from './pages/auth/ResetPassword';
import VerifyEmail from './pages/auth/VerifyEmail';
import Logout from './pages/student/Logout';

// Public Pages
import Home from './pages/public/Home';
import AllTutors from './pages/public/AllTutors';
import Service from "./pages/public/HomeOurservice";
import PeerMateSection from './pages/peermate/peermate';
import Faqs from './pages/public/Faq';
import Contact from './pages/public/Contact';
import Terms from './pages/public/Term';
import Help from './pages/public/HelpCenter';
import Privacy from './pages/public/PrivacyPolicy';
import TutorDetails from "./components/TutorDetails";
import RoleSelection from './components/RoleSelection/RoleSelection';
import Loginrole from "./components/RoleSelection/loginrole"
 
import Peermatehomepage  from "./pages/peermate/peermatehomepage";
import  Peerchat from "./pages/peermate/peermatechat";
import Videochat from "./pages/peermate/videopeermate";
import Courseselection from "./pages/courseselection"
// Dashboards
import StudentDashboard from './pages/student/Dashboard';
import Profile from './pages/student/Profile';
import MyClasses from './pages/student/MyClasses';
import Reviews from './pages/student/Reviews';
import Payment from './pages/student/Payment';
import Messages from './pages/student/Messages';
import Chat from './pages/student/Chat';
import Notifications from './pages/student/Notifications';
import Enroll from './pages/student/EnrollForm';
import Schedule from './pages/student/Schedule';
import Assignment from './pages/student/Assignment';
import SocialLoginSuccess from './pages/SocialLoginSuccess';
import PaymentSuccess from './pages/student/PaymentSuccess';
import Certification from "./pages/student/Certification"
import VerifyCertificate from "./pages/student/VerifyCertificate"
import Courserecommendation  from "./pages/student/courserecommendation"
import Current_courses from '../src/components/dashboard/CompletedCourses';
import Journal  from "../src/pages/student/Journal";
import NewJournalEntry from "../src/pages/student/Newjournalentry"
import GroupClasses from './pages/student/groupclasse';
import GroupClassDetails from './pages/student/GroupClassDetails';
import CourseReviewPage from "./pages/student/CourseReviewPage"
import Referal from "./pages/student/referal"
import Howitworks from "./pages/public/Howitworkspage"
import MarketplaceComingSoon from "./pages/public/MarketplaceComingSoon";
import TutorApp from './TutorApp';
import AdminApp from './AdminApp';
import CoHubApp from './CoHubApp';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <BrowserRouter>
      <ToastContainer 
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <Routes>
        {/* Auth Routes with Navbar and Footer */}
        <Route path="/login" element={<PublicLayout><Login /></PublicLayout>} />
        <Route path="/register" element={<PublicLayout><Register /></PublicLayout>} />
        <Route path="/forgot-password" element={<PublicLayout><ForgotPassword /></PublicLayout>} />
        <Route path="/reset-password/:token" element={<PublicLayout><ResetPassword /></PublicLayout>} />
        <Route path="/verify-email/:token" element={<VerifyEmail />} />
        <Route path="/logout" element={<PublicLayout><Logout /></PublicLayout>} />
       
        {/* Public Routes with Navbar and Footer */}
        <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
        <Route path="/tutors" element={<PublicLayout><AllTutors /></PublicLayout>} />
        <Route path="/faqs" element={<PublicLayout><Faqs /></PublicLayout>} />
        <Route path="/contact-us" element={<PublicLayout><Contact /></PublicLayout>} />
        <Route path="/terms" element={<PublicLayout><Terms /></PublicLayout>} />
        <Route path="/help" element={<PublicLayout><Help /></PublicLayout>} />
        <Route path="/privacy" element={<PublicLayout><Privacy /></PublicLayout>} />
        <Route path="/payment-success" element={<PublicLayout><PaymentSuccess /></PublicLayout>} />
        <Route path="/tutor-details/:id" element={<PublicLayout><TutorDetails /></PublicLayout>} />
       
        <Route path="/social-login-success" element={<PublicLayout><SocialLoginSuccess /></PublicLayout>} />
        <Route path='/RoleSelection'  element={<RoleSelection/>}/>
        <Route path='/Loginrole'  element={<Loginrole/>}/>

        <Route path="/courseselection" element={<Courseselection/>}/>
        <Route path="/Courseselection" element={<Courseselection/>}/>
        
        <Route path='/group-classes' element={<GroupClasses/>}/>
        <Route path='/group-classes/:classId' element={<GroupClassDetails/>}/>
        <Route path='/GroupClasses' element={<Navigate to='/group-classes' replace />} />
<Route path="/Howitworks" element={<Howitworks/>}/>
        <Route path="/Service" element={<Service/>}/>
        <Route path='/PeerMate' element={<PeerMateSection/>}/>
        <Route path='/marketplace' element={<MarketplaceComingSoon/>}/>
        <Route path='/Certification' element={<Certification/>}/>
        <Route path='/verify' element={<VerifyCertificate/>}/>
        <Route path='/verify-certificate' element={<VerifyCertificate/>}/>
        <Route path='/current_courses' element={Current_courses}/>
        <Route path='/Peermatehomepage' element={<Peermatehomepage/>}/>
        <Route path='/peerchat' element={<Peerchat/>}/>
        <Route path='/Videochat' element={<Videochat/>}/>
        <Route path="/Courserecommendation" element={<Courserecommendation/>}/>
        <Route path="/course/:id"  element={<CourseReviewPage />} />
        <Route path='/Referal' element={<Referal/>}/>

        {/* Dashboards without Navbar/Footer (can have their own layout later) */}
        <Route
          path="/dashboard"
          element={
            <StudentProtectedRoutes role="student">
              <PublicLayout><StudentDashboard /></PublicLayout>
            </StudentProtectedRoutes>
          }
        />

        <Route
          path="/profile"
          element={
            <StudentProtectedRoutes role="student">
              <PublicLayout><Profile /></PublicLayout>
            </StudentProtectedRoutes>
          }
        />

        <Route
          path="/my-classes"
          element={
            <StudentProtectedRoutes role="student">
              <PublicLayout><MyClasses /></PublicLayout>
            </StudentProtectedRoutes>
          }
        />

        <Route
          path="/payment"
          element={
            <StudentProtectedRoutes role="student">
              <PublicLayout><Payment /></PublicLayout>
            </StudentProtectedRoutes>
          }
        />

        <Route
          path="/reviews"
          element={
            <StudentProtectedRoutes role="student">
              <PublicLayout><Reviews /></PublicLayout>
            </StudentProtectedRoutes>
          }
        />

        <Route 
          path='/Journal' 
          element={
            <StudentProtectedRoutes role="student">
              <PublicLayout><Journal/></PublicLayout>
            </StudentProtectedRoutes>  
          }
        />

        <Route 
          path='/new-journal' 
          element={
            <StudentProtectedRoutes role="student">
              <PublicLayout><NewJournalEntry/></PublicLayout>
            </StudentProtectedRoutes>  
          }
        />

        <Route
          path="/messages"
          element={
            <StudentProtectedRoutes role="student">
              <PublicLayout><Messages /></PublicLayout>
            </StudentProtectedRoutes>
          }
        />

        <Route
          path="/messages/:studentId/:tutorid"
          element={
            <StudentProtectedRoutes role="student">
              <PublicLayout><Chat /></PublicLayout>
            </StudentProtectedRoutes>
          }
        />

        <Route
          path="/notifications"
          element={
            <StudentProtectedRoutes role="student">
              <PublicLayout><Notifications /></PublicLayout>
            </StudentProtectedRoutes>
          }
        />

        <Route
          path="/enroll"
          element={
            <StudentProtectedRoutes role="student">
              <PublicLayout><Enroll /></PublicLayout>
            </StudentProtectedRoutes>
          }
        />
        <Route
          path="/schedule"
          element={
            <StudentProtectedRoutes role="student">
              <PublicLayout><Schedule /></PublicLayout>
            </StudentProtectedRoutes>
          }
        />
        <Route
          path="/assignments"
          element={
            <StudentProtectedRoutes role="student">
              <PublicLayout><Assignment /></PublicLayout>
            </StudentProtectedRoutes>
          }
        />

        <Route path="/tutor/*" element={<TutorApp />} />
        <Route path="/admin/*" element={<AdminApp />} />
        <Route path="/cohub/*" element={<CoHubApp />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
